import { getPlatform } from "@/stores/useEnvConfigStore";
import { detectStandalone } from "@/hooks/pwa/useIsPwa";

export function isMobileLayout(): boolean {
  const currentPlatform = getPlatform();
  const isPwa = detectStandalone();

  return currentPlatform === "mobile" || !!isPwa;
}
